// Hook Actions Layer para OrderWsMessageMC
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { SIDEBAR_ACTIONS } from '../../../../constants/actionsConstants';
import { encodeWhatsAppMediaUrl } from '../../../../util/mediaUrlUtils';

export default function useOrderWsMessageActions({ message, onClick, url }) {
  const dispatch = useDispatch();

  // Handler para abrir el modal de detalles del pedido (solo acciones, no UI)
  const handleToggleModal = useCallback(() => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'OrderWsModalProductsMC',
        props: {
          message,
          onClick
        }
      }
    });
  }, [dispatch, message, onClick]);

  // Handler para click en imagen
  const handleImageClick = useCallback(() => {
    const safeUrl = encodeWhatsAppMediaUrl(url);
    if (safeUrl && typeof onClick === 'function') onClick(safeUrl);
  }, [url, onClick]);

  return {
    handleToggleModal,
    handleImageClick
  };
}
